import classNames from "classnames";
import useLocalStorage from "neetocommons/react-utils/useLocalStorage";
import { Moon, Sun } from "neetoicons";
import { Dropdown } from "neetoui";
import { useTranslation } from "react-i18next";

import {
  APP_THEME_LOCALSTORAGE_KEY,
  THEMES,
} from "components/FloatingActionMenu/constants";
import {
  setDarkTheme,
  setLightTheme,
} from "components/FloatingActionMenu/utils";

const { MenuItem } = Dropdown;

const ThemeSwitcher = () => {
  const { t } = useTranslation();

  const [appTheme, setAppTheme] = useLocalStorage(
    APP_THEME_LOCALSTORAGE_KEY,
    THEMES.LIGHT
  );
  const isDarkThemeSelected = appTheme === THEMES.DARK;

  const switchTheme = theme => {
    theme === THEMES.LIGHT ? setLightTheme() : setDarkTheme();
    setAppTheme(theme);
  };

  return (
    <MenuItem className="neeto-molecules-theme-switcher flex items-center justify-between gap-2 px-5 py-3">
      <div className="neeto-molecules-theme-switcher__label">
        {t("neetoMolecules.sidebar.themeSwitcher.label")}
      </div>
      <div
        className="neeto-molecules-theme-switcher__segmented-control"
        data-testid="theme-switcher-button"
      >
        <button
          data-testid="theme-switcher-light-button"
          type="button"
          className={classNames("neeto-molecules-theme-switcher__option", {
            "neeto-molecules-theme-switcher__option--active":
              !isDarkThemeSelected,
          })}
          onClick={() => switchTheme(THEMES.LIGHT)}
        >
          <Sun size={18} />
          {t("neetoMolecules.sidebar.themeSwitcher.light")}
        </button>
        <button
          data-testid="theme-switcher-dark-button"
          type="button"
          className={classNames("neeto-molecules-theme-switcher__option", {
            "neeto-molecules-theme-switcher__option--active":
              isDarkThemeSelected,
          })}
          onClick={() => switchTheme(THEMES.DARK)}
        >
          <Moon size={18} />
          {t("neetoMolecules.sidebar.themeSwitcher.dark")}
        </button>
      </div>
    </MenuItem>
  );
};

export default ThemeSwitcher;
